// extend libraries
import { Crncy } from '@paywithextend/localization'
import { connect } from 'react-redux'
import { getLocaleInfo } from 'src/localization/locales'
import { useCurrencyFormatter } from 'src/localization/useCurrencyFormatter'
import { RootState } from 'src/redux/createRootReducer'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
export { useCurrencyFormatter }

/** @deprecated */
export default connect((state: RootState) => {
  const locale = selectNullSafeLocaleFromState(state)
  return {
    locale: locale,
    defaultDisplayCurrency: getLocaleInfo(locale).currency,
  }
}, {})(Crncy)
